/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Download_ErrorInputs */

const en_tts_tool_download_error = /** @type {(inputs: Tts_Tool_Download_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't prepare that audio. Please generate it again.`)
};

const es_tts_tool_download_error = /** @type {(inputs: Tts_Tool_Download_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos preparar ese audio. Genéralo de nuevo.`)
};

/**
* | output |
* | --- |
* | "We couldn't prepare that audio. Please generate it again." |
*
* @param {Tts_Tool_Download_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_download_error = /** @type {((inputs?: Tts_Tool_Download_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Download_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_download_error(inputs)
	return en_tts_tool_download_error(inputs)
});